import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCloseCircleFilled = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("circle", {
		cx: 12,
		cy: 12,
		r: 10.5,
		stroke: "#D9D9D9"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M7.86283 17L12 12.8628L16.1372 17L17 16.1372L12.8628 12L17 7.86283L16.1372 7L12 11.1372L7.86283 7L7 7.86283L11.1372 12L7 16.1372L7.86283 17Z",
		fill: "#162395"
	})]
});
export default SvgCloseCircleFilled;
